import { render, staticRenderFns } from "./SublimitsQuotator.vue?vue&type=template&id=52b195f6&"
import script from "./SublimitsQuotator.vue?vue&type=script&lang=js&"
export * from "./SublimitsQuotator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports